import { CashOut } from "./CashOutOption";

export namespace CancelRiderFromInceptionSubmission {
  export interface SubmitedData {
    policy: {
      policyNo: string
    }
    attributesExt: {
      RIDER_REFUND_AMOUNT: number
      // SUSPENSE_AMOUNT: number
      REFUNDABLE_FEE_AMOUNT: number
      NET_AMOUNT_AVAILABLE: number
      TOTAL_PAYOUT_AMOUNT: number
      REASON: string
    }
    cashOutOptions: Array<CashOut.Option>
    lifeAssureds: Array<{
      lifeAssured: string
      riders: Array<{
        productCode: string
        riskCommDate: string
        riskCessDate: string
        sumAssured: number
        installmentPremium: number
        lifeNo: string
        coverageNo: string
        riderNo: string
        status: string
      }>
    }>
  }
}